import { Box, Button, Drawer, DrawerProps, FormControlLabel, Grid, IconButton, Typography } from "@mui/material"
import { icons } from "../../../../utils/icons"
import { useTranslation } from "react-i18next"
import { useStyles } from "./styles"
import { DynamicFormRef } from "../../../../components/dynamicFormRef"
import { useBody } from "./body"
import { BaseMenu } from "../../../../components"
import { DrawerEvidences } from "../../../../components/evidences"
import { EvidenceData, EvidenceOptionType } from "../../../../hooks/evidences/typyng"
import { ReactElement, createRef, useEffect } from "react"
import SimpleModal from "../../../../components/modal/simpleModal"
import { ReportFolio } from "../repotFolios"
import { ClickedBox } from "../clickedBox"
import { IOSSwitch } from "../../../../components/dinamicForm/switch"
import { ReportFolioRef } from "../repotFolios/types"

interface ActionPlanDrawerProps {
  DrawerProps: DrawerProps
  arrowBack: ArrowBackActionPlan
  cancel: () => void
  shrink: () => void
  validate?: boolean
  defaultValues?: {
    dataFolios: Record<string, string | number | boolean>
    activeFolios?: boolean
    EvidenceData: EvidenceData
    data: Record<string, string | number | boolean>
    description: Record<string, string | number | boolean>
    evidenceFolio?: EvidenceData;
    options?: {
      evidences?: {
        sameConfig: boolean;
      }
    }
    // limitFolio?: Record<string, string | number | boolean>;
    // rejectsFolio?: Record<string, string | number | boolean>;
  }
  activeFolios?: boolean
  reportFolioOpen: boolean
  questName: string
  areThereSomeEvidence: boolean
  isGeneral: boolean
}

type ArrowBackActionPlan = (payload: {
  evidence: EvidenceData[];
  // evidenceFolioManagement: EvidenceData[]
  data: Record<string, string | number | boolean>;
  evidenceDataFolios?: EvidenceData[];
  dataFolios?: Record<string, string | number | boolean> | undefined;
  options?: Record<string, { sameConfig: boolean }>
}) => void

export type { ArrowBackActionPlan }

const ActionPlanDrawer = (props: ActionPlanDrawerProps) => {
  const { t } = useTranslation()
  const {
    description,
    generalQuestions,
    evidencesOptions,
    areThereSomeCheck,
    refsByKey,
    setRef,
    handleActivedChecks,
    refReport,
    // evidencesFolioComment,
    ...rest
  } = useBody({ cancel: props.cancel, options: props.defaultValues?.options, activeFolio: { active: Boolean(props.defaultValues?.activeFolios), open: Boolean(props?.DrawerProps?.open) }, defaultValues: props.defaultValues?.EvidenceData, data: props.defaultValues?.data, defaultValuesFolios: props.defaultValues?.evidenceFolio })
  const styles = useStyles()
  const saveActionPlan = () => {
    const body = { ...refsByKey['generalQuestions']?.getValues(), ...refsByKey['description']?.getValues() } as Record<string, string | number | boolean>
    const active = !!rest.folioData.active
    const body2 = refReport.current?.getData()
    const actived = refReport.current?.activated
    props.arrowBack({
      evidence: evidencesOptions.evidencesData,
      // evidenceFolioManagement: evidencesFolioComment.evidencesData,
      data: body,
      evidenceDataFolios: active && actived?.evidence ? rest.evidencesFolios.evidencesData : undefined,
      dataFolios: active ? body2 : undefined as any,
      options: rest.options
    })
    rest.cleanActionPlanDrawer()
  }

  useEffect(() => {
    const body = Object.entries(props.defaultValues?.data ?? {})
    handleActivedChecks(!!body?.length && !!body?.some(([key, value]) => key.includes('check') && !!value))
  }, [props.defaultValues?.data])
  useEffect(() => {
    if (!!props.activeFolios && props?.DrawerProps?.open) {
      rest.activeFoliosSection()
    } else {
      rest.cleanFolios()
    }
  }, [props.activeFolios, props?.DrawerProps?.open])

  useEffect(() => {
    if (props?.DrawerProps?.open && !!props.defaultValues?.EvidenceData?.length) {
      evidencesOptions.fillData({ defaultValues: props.defaultValues?.EvidenceData })
    }
  }, [props?.DrawerProps?.open])
  return (
    <Drawer {...props.DrawerProps} anchor="right">
      <Box sx={[{ width: '100%', paddingBottom: 1 }]}>
        <Box sx={styles.arrowHeaderDrawerContainer}>
          <IconButton
            sx={styles.closeSettings}
            onClick={rest.cancelActionPlan}
          >
            {icons('arrow-left-fill')}
          </IconButton>

          <Typography className="quest-name-header">Volver a la Configuración{props.isGeneral ? ' de Cuestionario' : ''}</Typography>

          {!!rest.folioData.isOpen && (
            <IconButton
              sx={styles.shrink}
              onClick={() => {
                rest.closeFolio()
              }}
            >
              {icons('shrink')}
            </IconButton>
          )}
        </Box>
      </Box>

      <Grid container sx={styles.userDetail({ open: rest.folioData.isOpen })}>
        <Grid item xs={rest.folioData.isOpen ? 6 : 12} sx={[styles.actionPlanDrawer({ open: rest.folioData.isOpen }), styles.borderTop]}>
          <Typography className="quest_name_title padding_title">Plan de acción</Typography>


          {(!areThereSomeCheck && (!evidencesOptions.evidencesCount || (!rest.actions.evidence && !!evidencesOptions.evidencesCount))) && (
            <Typography sx={styles.warning} className="padding_title">
              <span>*</span>
              {t('Questionarie.order.addOnceEvidence')}
            </Typography>
          )}

          <Box className="containerUserDetail">
            <DynamicFormRef
              ref={element => {
                setRef(element, 'description')
                return refsByKey['description']
              }}
              removeForm
              validateField={props.validate}
              defaultValues={props.defaultValues?.description}
              parentWrapper={({ children }) => <Box sx={{ display: 'flex', flexWrap: "wrap", gap: '16px' }} children={children} />}
              model={description}
            />

            <Box sx={styles.alignGrid}>
              <DynamicFormRef
                ref={element => {
                  setRef(element, 'generalQuestions')
                  return refsByKey['generalQuestions']
                }}
                removeForm
                validateField={props.validate}
                onChange={() => {
                  const body = Object.entries(refsByKey['generalQuestions']?.getValues() ?? {})
                  handleActivedChecks(!!body?.length && !!body?.some(([key, value]) => key.includes('check') && !!value))
                }}
                model={generalQuestions}
                defaultValues={props.defaultValues?.data}
                parentWrapper={({ children }) => <Grid container alignItems="center" children={children} />}
              />
            </Box>

            <ClickedBox
              children={(
                <FormControlLabel
                  control={
                    <IOSSwitch
                      {...rest}
                      checked={rest.actions.evidence}
                      onChange={(e, value) => {
                        rest.handleActivedActions({ name: 'evidence', value: value })
                      }}
                      sx={{ m: 1 }}
                    />
                  }
                  label={t('Questionarie.sections.evidenceTypes3')}
                />
              )}
              click={(e) => {
                evidencesOptions.clickOption({ item: {}, defaultEvidencesData: evidencesOptions.evidencesData })
              }}
              active={rest.actions.evidence}
            />

            <ClickedBox
              children={(
                <FormControlLabel
                  control={
                    <IOSSwitch
                      {...rest}
                      checked={rest.actions.reportFolio}
                      onChange={(e, value) => {
                        if (!rest.folioData.active) {
                          rest.handleActivedActions({ name: 'reportFolio', value: value })
                        } else {
                          rest.removeFolios({ name: 'reportFolio' })
                        }
                      }}
                      sx={{ m: 1 }}
                    />
                  }
                  label={t('Questionarie.reportFolio')}
                />
              )}
              click={() => {
                if (!rest.folioData.active) {
                  rest.openModal()
                } else {
                  rest.openFolio()
                }
              }}
              active={rest.actions.reportFolio}
            />
          </Box>

          <Box sx={styles.footer}>
            <Button onClick={saveActionPlan} variant="contained">{t('general.save')}</Button>

            <Button onClick={rest.cancelActionPlan}>{t('general.cancel')}</Button>
          </Box>
        </Grid>

        <Grid item xs={6} p={3} sx={[styles.borderTop, styles.hidden({ open: !!rest?.folioData?.isOpen })]}>
          <ReportFolio
            ref={refReport}
            evidencesCount={rest.evidencesFolios.evidencesCount}
            buttonsDown
            limitFoliosProps={{
              ref: (element) => {
                setRef(element, 'folioLimit')
                return refsByKey['folioLimit']
              },
              removeForm: true,
              styleSx: { width: '100%' },
              defaultValues: props.defaultValues?.limitFolio as any,
              parentWrapper: ({ children }: { children: ReactElement }) => <Grid spacing={2} alignItems='center' container children={children} />,
              model: rest.folioModelReport,
              onChange: (payload) => {
                rest.handleErrors()
                const name = payload?.current as string
                rest.changeFolio({ type: 'limit', name: name, value: payload?.[name] ?? null })
              }
            }}
            rejectsFolioProps={{
              ref: element => {
                setRef(element, 'folioReject')
                return refsByKey['folioReject']
              },
              removeForm: true,
              defaultValues: props.defaultValues?.rejectsFolio,
              parentWrapper: ({ children }) => <Grid spacing={2} alignItems='center' container children={children} />,
              model: rest.folioModel,
              onChange: (payload) => {
                rest.handleErrors()
                const name = payload?.current as string
                rest.changeFolio({ type: 'rejects', name: name, value: payload?.[name] ?? null })
              }
            }}
            defaultData={props.defaultValues?.dataFolios}
            openMenu={rest.evidencesFolios.openMenu as any}
            removeFolios={rest.removeFolios}
            evidenceFolio={props.defaultValues?.evidenceFolio}
            baseMenuProps={{
              anchorEl: rest.evidencesFolios.anchorEl,
              setAnchorEl: () => { rest.evidencesFolios.closeMenu() },
              menuItems: rest.evidencesFolios.menu,
              click: (item) => { rest.evidencesFolios.clickOption({ item }) },
            }}
            drawerEvidencesProps={{
              refsByKey: rest.evidencesFolios.refsByKey,
              defaultValues: rest.evidencesFolios.evidencesData,
              open: rest.evidencesFolios.openEvidenceDrawer,
              setRef: rest.evidencesFolios.setRef,
              save: (data, options) => { rest.evidencesFolios.saveEvidence(data || [],) },
              cancel: rest.evidencesFolios.cancelEvidence,
            }}
          />
        </Grid>
      </Grid>

      <BaseMenu
        sx={styles.border}
        anchorEl={evidencesOptions.anchorEl}
        setAnchorEl={() => { evidencesOptions.closeMenu() }}
        menuItems={evidencesOptions.menu}
        click={(item) => { evidencesOptions.clickOption({ item }) }}
      />

      <DrawerEvidences
        optionType={EvidenceOptionType.CREATOR}
        options={rest.options?.evidences}
        refsByKey={evidencesOptions.refsByKey}
        defaultValues={evidencesOptions.evidencesData}
        open={evidencesOptions.openEvidenceDrawer}
        setRef={evidencesOptions.setRef}
        save={(data, options) => {

          rest.setOptions(prev => ({ ...prev, evidences: options }))
          evidencesOptions.saveEvidence(data || [], () => { })
        }}
        cancel={evidencesOptions.cancelEvidence}
        headerLabel="Volver al plan de acción"
      />

      <SimpleModal
        open={!!rest.modal.open}
        close={() => { rest.closeModal() }}
        title={rest.modal.title}
        description={rest.modal.description}
        cancelText={t('general.cancel')}
        buttonText={t('general.confirm')}
        back={() => { if (rest.modal.cancel) rest.modal.cancel() }}
        next={() => { if (rest.modal.confirm) rest.modal.confirm() }}
      />
    </Drawer>
  )
}

export { ActionPlanDrawer }
